<template>
  <v-app>
    <v-app-bar app dark color="primary">
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      <v-toolbar-title>TIKM</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title v-if="isLoggedIn">
        Welcome
        <span v-if="isTeacher">teacher</span>
        <span v-if="isAdmin">admin</span>
        {{ userName }}!
      </v-toolbar-title>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" fixed temporary>
      <v-list nav>
        <v-list-item-group>
          <v-list-item to="/">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-item to="/password/admin" v-if="isLoggedIn && isAdmin">
            <v-list-item-icon>
              <v-icon>mdi-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Change Admin PW</v-list-item-title>
          </v-list-item>

          <v-list-item to="/email/admin" v-if="isLoggedIn && isAdmin">
            <v-list-item-icon>
              <v-icon>mdi-email</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Change Admin Email</v-list-item-title>
          </v-list-item>

          <v-list-item to="/account" v-if="isLoggedIn && account">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Account</v-list-item-title>
          </v-list-item>

          <v-list-item to="/transactions" v-if="isLoggedIn && account">
            <v-list-item-icon>
              <v-icon>mdi-credit-card-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Transactions</v-list-item-title>
          </v-list-item>

          <v-list-item to="/creditrecords" v-if="isLoggedIn && account">
            <v-list-item-icon>
              <v-icon>mdi-cash-usd-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Credit Records</v-list-item-title>
          </v-list-item>

          <v-list-item to="/password" v-if="isLoggedIn && account">
            <v-list-item-icon>
              <v-icon>mdi-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Change password</v-list-item-title>
          </v-list-item>
          <v-list-item to="/email" v-if="isLoggedIn && account">
            <v-list-item-icon>
              <v-icon>mdi-email</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Change email</v-list-item-title>
          </v-list-item>

          <!-- <v-list-item to="/developer">
            <v-list-item-icon>
              <v-icon>mdi-information</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Developer Info</v-list-item-title>
          </v-list-item>-->
          <v-list-item @click="logout" v-if="isLoggedIn">
            <v-list-item-icon>
              <v-icon>mdi-exit-to-app</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <ErrorMessage />
      <router-view></router-view>
      <FullScreenLoading />
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ErrorMessage from "@/components/ErrorMessage.vue";
import FullScreenLoading from "@/components/FullScreenLoading.vue";
export default {
  name: "App",
  data: () => ({
    drawer: false
  }),
  created() {
    this.$vuetify.theme.dark = false;
    this.$store.state.fullScreenLoading = false;
    //this.$vuetify.theme.dark = true;
  },
  components: { ErrorMessage, FullScreenLoading },
  computed: {
    ...mapState({
      userName: state => state.user.firstName,
      account: state => state.account
    }),
    ...mapGetters(["isLoggedIn", "isTeacher", "isAdmin"])
  },
  methods: {
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    }
  }
};
</script>
